export * from './common'
export * from './constant'
export * from './dateHandles'
export * from './filesize'
export * from './storage'
export * from './canvasTool'

// Chat utilities
export const extractDocumentsFromText = (text) => {
    let documents = []

    try {
        const parsed = JSON.parse(text)
        if (Array.isArray(parsed)) {
            documents = parsed
        } else if (parsed && parsed.document_title && parsed.public_url) {
            documents = [parsed]
        }
    } catch (e) {
        const jsonMatch = text.match(/(\[[\s\S]*\])/)
        if (jsonMatch) {
            try {
                const parsed = JSON.parse(jsonMatch[1])
                if (Array.isArray(parsed)) {
                    documents = parsed
                    text = text.replace(jsonMatch[1], '').trim()
                }
            } catch (innerE) {
                console.log('Document JSON extraction failed:', innerE)
            }
        }
    }

    return { documents, text }
}

export const deduplicateDocuments = (docs) => {
    if (!docs || !Array.isArray(docs)) return []
    const seenTitles = new Set()
    return docs.filter(doc => {
        if (seenTitles.has(doc.document_title)) {
            return false
        }
        seenTitles.add(doc.document_title)
        return true
    })
}
